if (!window.__scScriptsInit) {
  window.__scScriptsInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    initRevealSc();
    initFaqSc();
    initCarruselSc();
    initGaleriaSc();
  });
}

function initRevealSc() {
  var els = document.querySelectorAll('.sc-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('sc-visible'); });
    return;
  }
  var vh = window.innerHeight || document.documentElement.clientHeight;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('sc-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) {
    var rect = el.getBoundingClientRect();
    if (rect.top < vh && rect.bottom > 0) {
      el.classList.add('sc-visible');
    } else {
      obs.observe(el);
    }
  });
}

function initFaqSc() {
  var items = document.querySelectorAll('.sc-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.sc-faq-pregunta');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('sc-faq-open');
      items.forEach(function (other) {
        other.classList.remove('sc-faq-open');
        other.querySelector('.sc-faq-pregunta').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('sc-faq-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

function initCarruselSc() {
  document.querySelectorAll('[data-sc-carrusel]').forEach(function (wrap) {
    var track = wrap.querySelector('.sc-carrusel-track');
    var prev = wrap.querySelector('[data-sc-prev]');
    var next = wrap.querySelector('[data-sc-next]');
    if (!track) return;
    var card = track.querySelector('.sc-resena-card');
    function step() { return card ? card.getBoundingClientRect().width + 20 : 300; }
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  });
}

function initGaleriaSc() {
  var galeria = document.querySelector('[data-sc-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-sc-imagen-principal]');
  var thumbs = galeria.querySelectorAll('[data-sc-thumb]');
  if (!principal || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-sc-full');
      var alt = thumb.getAttribute('data-sc-alt') || '';
      if (!src) return;
      principal.style.opacity = '0';
      setTimeout(function () {
        principal.src = src;
        principal.alt = alt;
        principal.style.opacity = '1';
      }, 150);
      thumbs.forEach(function (t) { t.classList.remove('sc-thumb-activa'); });
      thumb.classList.add('sc-thumb-activa');
    });
  });
}
